import { render } from "./HomePageComponent.vue?vue&type=template&id=1dd8bba1&scoped=true"
import script from "./HomePageComponent.vue?vue&type=script&lang=js"
export * from "./HomePageComponent.vue?vue&type=script&lang=js"

import "./HomePageComponent.vue?vue&type=style&index=0&id=1dd8bba1&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@4.9.5__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd8bba1"]])

export default __exports__